/* High Contrast Toggle (common)
 * - Toggles `is-high-contrast`
 * - Persists explicit choice to localStorage
 * - Respects prefers-contrast if no explicit choice
 */
(function () {
    'use strict';

    const STORAGE_KEY = 'osram:highContrast';

    function getRootElement() {
        return document.body || document.documentElement;
    }

    function setHighContrast(on, persist) {
        const el = getRootElement();
        if (!el) return;

        if (on) el.classList.add('is-high-contrast');
        else el.classList.remove('is-high-contrast');

        const toggleBtn = document.getElementById('hc-toggle');
        if (toggleBtn) toggleBtn.setAttribute('aria-pressed', !!on);

        updateToggleLabel(!!on);

        if (persist) {
            const cache = typeof window !== 'undefined' && window.localStorageCache;
            if (cache && typeof cache.cacheSet === 'function') {
                cache.cacheSet(STORAGE_KEY, on ? 'on' : 'off');
            }
            // TODO - implement server-side persistence here depending on feedback
        }
    }

    function updateToggleLabel(isOn) {
        const toggleBtn = document.getElementById('hc-toggle');
        if (!toggleBtn) return;

        const labelEl = toggleBtn.querySelector('.hc-toggle__label');
        const onText = toggleBtn.dataset && toggleBtn.dataset.labelOn ? toggleBtn.dataset.labelOn : 'Lower contrast';
        const offText = toggleBtn.dataset && toggleBtn.dataset.labelOff ? toggleBtn.dataset.labelOff : 'Increase contrast';
        const text = isOn ? onText : offText;

        if (labelEl) {
            labelEl.textContent = text;
        }

        toggleBtn.setAttribute('aria-label', text);
    }

    function init() {
        //TODO - this is implemented with the footer toggle being implemented as part of LR webcontent; will need to revisit if we move it
        const toggleBtn = document.getElementById('hc-toggle');
        if (!toggleBtn) return;


        const cache = typeof window !== 'undefined' && window.localStorageCache;
        const saved = cache && typeof cache.cacheGet === 'function'
            ? cache.cacheGet(STORAGE_KEY)
            : null;

        const mq = window.matchMedia && window.matchMedia('(prefers-contrast: more)');

        // Apply saved preference first, otherwise respect system preference
        if (saved === 'on' || saved === 'off') {
            setHighContrast(saved === 'on', false);
        } else if (mq && mq.matches) {
            setHighContrast(true, false);
        }

        toggleBtn.addEventListener('click', function () {
            const root = getRootElement();
            const isOn = root && root.classList.contains('is-high-contrast');
            setHighContrast(!isOn, true);
        });

        // If user hasn't explicitly chosen, respond to system preference changes
        if (mq && typeof mq.addEventListener === 'function') {
            mq.addEventListener('change', function (e) {
                const explicit = cache && typeof cache.cacheGet === 'function' ? cache.cacheGet(STORAGE_KEY) : null;
                if (explicit === null) {
                    setHighContrast(e.matches, false);
                }
            });
        }
    }

    // Initialize on DOM ready (or immediately if already ready)
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.amsHighContrastToggle = {
        setHighContrast: setHighContrast,
    };
})();
